import axios from 'axios';
import qs from 'qs';
import { formattedAnswersForAPI, calculatePoints } from '~/util';

/**
 * Rest endpoints URLs
 */
const questionRestEndpoint = `${ LearnDashData.rest.root }${ LearnDashData.rest.namespace }/${ LearnDashData.rest.base.question }`;
const lessonsRestEndpoint = `${ LearnDashData.rest.root }${ LearnDashData.rest.namespace }/${ LearnDashData.rest.base.lessons }`;
const topicRestEndpoint = `${ LearnDashData.rest.root }${ LearnDashData.rest.namespace }/${ LearnDashData.rest.base.topic }`;
const quizRestEndpoint = `${ LearnDashData.rest.root }${ LearnDashData.rest.namespace }/${ LearnDashData.rest.base.quiz }`;
const sectionHeadingRestEndpoint = `${ LearnDashData.rest.root }${ LearnDashData.rest.namespace }/sections`;

/**
 * Map of enpoints per entity type
 */
const endpointMap = {
	question: questionRestEndpoint,
	lesson: lessonsRestEndpoint,
	topic: topicRestEndpoint,
	quiz: quizRestEndpoint,
};

/**
 * Deletes an entity
 *
 * @param {number} id   The entity id.
 * @param {string} type Post data we want to delete.
 */
export const deleteEntity = async ( id, type ) => {
	const res = await axios.delete(
		`${ endpointMap[ type ] }/${ id }?force=true`,
		{
			headers: {
				'X-WP-Nonce': LearnDashData.rest.nonce,
			},
		}
	);

	return res.status;
};

/**
 * Get question details from the REST API
 *
 * @param {number} id The question id
 */
export const getQuestion = async ( id ) => {
	const res = await axios.get( `${ questionRestEndpoint }/${ id }`, {
		headers: {
			'X-WP-Nonce': LearnDashData.rest.nonce,
		},
	} );

	return res.data;
};

/**
 * Updates a question
 *
 * @param {number} id   The question id
 * @param {Object} data Fields we want to update.
 */
export const updateQuestion = async ( id, data ) => {
	const res = await axios.post( `${ questionRestEndpoint }/${ id }`, data, {
		headers: {
			'X-WP-Nonce': LearnDashData.rest.nonce,
		},
	} );

	return res.status;
};

/**
 * Updates an answer
 *
 * @param {number} id   The parent question id
 * @param {Object} answers Fields we want to update.
 * @param {boolean} shouldCalculatePoints
 */
export const updateAnswer = async (
	id,
	answers,
	shouldCalculatePoints = false
) => {
	// Convert data to match API format
	const formattedAnswers = formattedAnswersForAPI( answers );
	let data;

	if ( shouldCalculatePoints ) {
		const { points, maxPoints } = calculatePoints( answers );
		data = {
			_points: points,
			_maxPoints: maxPoints,
			_answerData: formattedAnswers,
		};
	} else {
		data = {
			_answerData: formattedAnswers,
		};
	}

	const res = await axios.post(
		`${ questionRestEndpoint }/${ id }`,
		{
			...data,
		},
		{
			headers: {
				'X-WP-Nonce': LearnDashData.rest.nonce,
			},
		}
	);

	return res.status;
};

/**
 * Makes POST request to the AJAX endpoint
 *
 * @param {Object} payload The payload to send to the server
 * @param {Object} options
 */
export const ajaxRequest = async ( payload, options = {} ) => {
	const res = await axios.post(
		LearnDashData.ajaxurl,
		qs.stringify( payload ),
		options
	);

	return res;
};

/**
 * Adds a section header
 *
 * @param {number} id    The entity id
 * @param {Array}  array Section Headings we want to add
 */
export const addSectionHeading = async ( id, array ) => {
	const res = await axios.post(
		`${ sectionHeadingRestEndpoint }/${ id }`,
		{ sections: JSON.stringify( array ) },
		{
			headers: {
				'X-WP-Nonce': LearnDashData.rest.nonce,
			},
		}
	);

	return res.status;
};
